import { ROLES, TASK_MODULES } from '@/common/constants/constants';
import routes from '@/app/routing/routes';

export const ADMIN_ROLES = [ROLES.EAC_ADMIN, ROLES.FH_ADMIN];
export const USER_ROLES = [ROLES.USER];

export const getAuthorizedRedirectPath = (user) =>
  user?.role === ROLES.USER
    ? `${routes.dashboard.taskList}/${TASK_MODULES.IMMEDIATE}`
    : routes.adminPanel.decedents;
